import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { ButtonProps } from 'antd/lib/button';
import Button from 'components/Base/Button/Button';
import { ButtonVariant } from '../../Base/Button/Button.styles';

export interface DownloadButtonProps
  extends Omit<ButtonProps, 'onClick' | 'variant'> {
  /**
   * URL of the file to download
   */
  url?: string;
  /**
   * Button variant (primary, ghost, etc.)
   */
  variant?: ButtonVariant;
  /**
   * Optional click handler that overrides the default download behavior
   */
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  /**
   * Button label - can be string or React node
   * If not provided, only the download icon will be shown
   */
  label?: React.ReactNode;
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  url,
  onClick,
  label,
  variant = 'ghost',
  type = 'text',
  ghost = true,
  ...restProps
}) => {
  const handleDownload = (event: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(event);
      return;
    }

    if (url) {
      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = url.split('/').pop() || 'download';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Button
      variant={variant}
      type={type}
      ghost={ghost}
      icon={<DownloadOutlined />}
      onClick={handleDownload}
      {...restProps}
    >
      {label}
    </Button>
  );
};

export default DownloadButton;
